
const collectionId = document.getElementById('collection-top') ? document.getElementById('collection-top').getAttribute('data-collection-id') : document.getElementById('collection-premium-top').getAttribute('data-collection-id');

// Open collection admin using Konami
if(collectionId) {
  const konamiCollectionAdmin = [
    'up',
    'up',
    'down',
    'down',
    'left',
    'right',
    'left',
    'right',
    'a',
    'd',
    'm',
    'i',
    'n'
  ];
  let isDev = window.location.hostname.indexOf('chupi-dev') > -1;
  let storeName = isDev ? 'chupi-dev2' : 'chupi-jewellery';
  let adminUrl = `https://admin.shopify.com/store/${storeName}/collections/${collectionId}`;
  doCustomKonamiCode(konamiCollectionAdmin, () => {
    window.open(adminUrl, '_blank').focus();
  })
}